import IntegrationConfig from "@/IntegrationConfig";
import RelaxManager from "./managers/RelaxManager";
import EveryMatrixManager from "./managers/EveryMatrixManager";
import ThreePiManager from "./managers/ThreePiManager";
import GameBridgeManager from "./managers/GameBridgeManager";
import BetfairManager from "./managers/BetfairManager";
import {Adapter} from '@/Imports'
import GanManager from "./managers/GanManager";

export default class IntegrationManager {
  constructor() {
    if (IntegrationConfig.INTEGRATION_RELAX) {
      const manager = new RelaxManager()
      const adapter = new Adapter(manager)
      manager.init(adapter)
    }
 
    if (IntegrationConfig.INTEGRATION_EVERYMATRIX) {
      const manager = new EveryMatrixManager()
      const adapter = new Adapter(manager)
      manager.init(adapter)
    }

    if (IntegrationConfig.INTEGRATION_THREE_PI) {
      const manager = new ThreePiManager()
      const adapter = new Adapter(manager)
      manager.init(adapter)
    }

    if (IntegrationConfig.INTEGRATION_GAE_BRIDGE) {
      const manager = new GameBridgeManager()
      const adapter = new Adapter(manager)
      manager.init(adapter)
    }

    if (IntegrationConfig.INTEGRATION_BETFAIR) {
      const manager = new BetfairManager()
      const adapter = new Adapter(manager)
      manager.init(adapter)
    }

    if (IntegrationConfig.INTEGRATION_GAN) {
      const manager = new GanManager()
      const adapter = new Adapter(manager)
      manager.init(adapter)
    }
  }
}
